import { useEffect, useState } from 'react';
import { db, auth } from '../../../firebaseConfig';
import {
  collection,
  getDocs,
  addDoc,
  onSnapshot,
  doc,
  getDoc
} from 'firebase/firestore';
import './index.css';
import { toast } from 'react-toastify';

const ServiceRequests = () => {
  const [villas, setVillas] = useState([]);
  const [requests, setRequests] = useState([]);
  const [villaId, setVillaId] = useState('');
  const [service, setService] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchVillas = async () => {
      try {
        const villaSnapshot = await getDocs(collection(db, 'villas'));
        setVillas(
          villaSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
        );
      } catch (error) {
        console.error('Error fetching villas:', error);
      }
    };

    fetchVillas();

    const unsub = onSnapshot(
      collection(db, 'serviceRequests'),
      (snapshot) => {
        setRequests(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
        );
      },
      (error) => {
        console.error('Error listening to service requests:', error);
      }
    );

    return () => unsub();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!villaId || !service) {
      alert('Please select a villa and service');
      return;
    }

    const selectedVilla = villas.find((v) => v.id === villaId);
    const user = auth.currentUser;

    if (!user) {
      toast.error('No user is currently logged in');
      return;
    }

    const ownerId = user.uid;

    try {
      const profileDocRef = doc(db, 'users', ownerId, 'ownerDetails', 'profile');
      const profileDoc = await getDoc(profileDocRef);

      if (!profileDoc.exists()) {
        throw new Error('Owner profile data not found');
      }

      const ownerData = profileDoc.data();
      const ownerDetails = {
        ownerEmail: ownerData.email || 'unknown@travelunbounded.com',
        ownerName: ownerData.name || 'Unknown Owner',
        phoneNumber: ownerData.phone || '-',
      };

      const docRef = await addDoc(collection(db, 'serviceRequests'), {
        villaId,
        villaTitle: selectedVilla ? selectedVilla.title : '',
        service,
        message,
        date: new Date().toISOString(),
        status: 'pending',
      });

      const response = await fetch('https://luxe-backend.netlify.app/send-service-request-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          villaId,
          villaTitle: selectedVilla ? selectedVilla.title : '',
          service,
          message,
          requestId: docRef.id,
          date: new Date().toISOString(),
          ownerEmail: ownerDetails.ownerEmail,
          ownerName: ownerDetails.ownerName,
          phoneNumber: ownerDetails.phoneNumber,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to send email notification');
      }

      toast.success('Service request submitted and emails sent successfully!');
      setVillaId('');
      setService('');
      setMessage('');
    } catch (error) {
      console.error('Error submitting service request:', error);
      toast.error('Error submitting service request or sending emails: ' + error.message);
    }
  };

  const pendingRequests = requests.filter((r) => r.status === 'pending');
  const completedRequests = requests.filter((r) => r.status === 'completed');

  return (
    <div className="service-dashboard">
      <h2 className="service-title">Service Requests</h2>

      <div className="service-activity-section">
        <div className="service-activity-card">
          <h6>Pending Requests ({pendingRequests.length})</h6>
          <ul>
            {pendingRequests.map((req) => (
              <li key={req.id}>
                {req.service} - {req.villaTitle} -{' '}
                {new Date(req.date).toLocaleDateString()}
              </li>
            ))}
          </ul>
        </div>
        <div className="service-activity-card">
          <h6>Completed Requests ({completedRequests.length})</h6>
          <ul>
            {completedRequests.map((req) => (
              <li key={req.id}>
                {req.service} - {req.villaTitle} -{' '}
                {new Date(req.date).toLocaleDateString()}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="service-request-form">
        <h4>New Service Request</h4>
        <form onSubmit={handleSubmit}>
          <div className="service-form-group">
            <label>Villa:</label>
            <select
              value={villaId}
              onChange={(e) => setVillaId(e.target.value)}
              required
            >
              <option value="">Select Villa</option>
              {villas.map((villa) => (
                <option key={villa.id} value={villa.id}>
                  {villa.title}
                </option>
              ))}
            </select>
          </div>

          <div className="service-form-group">
            <label>Service:</label>
            <select
              value={service}
              onChange={(e) => setService(e.target.value)}
              required
            >
              <option value="">Select Service</option>
              <option value="Cleaning">Cleaning</option>
              <option value="Maintenance">Maintenance</option>
              <option value="Repairs">Repairs</option>
            </select>
          </div>

          <div className="service-form-group">
            <label>Message:</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Any additional details..."
            />
          </div>

          <button className="service-submit-btn" type="submit">
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default ServiceRequests;